import { TransitionStopReason } from './types';

export const RESET_TRANSITION_STYLE = {
  transition: '',
};

export const EVENT_TYPE_TO_ANIMATION_STOP_REASON: Record<string, TransitionStopReason> = {
  transitionend: TransitionStopReason.end,
  transitioncancel: TransitionStopReason.cancel,
};
